import * as Revisions from '../services/Revisions'

export const RECEIVE_REVISIONS = 'RECEIVE_REVISIONS'
export const HIDE_REVISIONS = 'HIDE_REVISIONS'
export const RECEIVE_DELETED_LOCATIONS = 'LOAD_DELETED_LOCATIONS'

const findRevisionResponse = (data) => {
  return {
    type: RECEIVE_REVISIONS,
    data: data
  }
}

const loadDeleteLocationsResponse = (data) => {
  return {
    type: RECEIVE_DELETED_LOCATIONS,
    data: data
  }
}

export const findRevisions = (entity,id,property) => (dispatch, getState) => {
  Revisions.getRevisions(entity,id,property).then( (revisions) => dispatch(findRevisionResponse({ entity,id,property,revisions})))
}

export const hideRevisions = () => (dispatch, getState) => {
  dispatch({type: HIDE_REVISIONS})
}

export const loadDeletedLocations = (group) => (dispatch, getState) => {
  Revisions.getDeletedLocations(group).then( (locations) => dispatch(loadDeleteLocationsResponse({ group, locations})))
}